import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, forkJoin } from 'rxjs';
import { map } from 'rxjs/operators';
import { Package } from "src/app/dto";

@Injectable({
  providedIn: 'root'
})

export class PackageDataLoaderService {
  constructor(private http: HttpClient) { }

  loadData(): Observable<Array<Package>> {
    const packageData$ = this.http.get('/assets/data/africom.packages..json');

    return packageData$.pipe(
      map((packageData: any) => packageData.phones)
    );
  }
}